import Immutable from 'immutable';
import { ActionTypes } from './actions';

export const initialState = Immutable.fromJS({});
const setHighlightsByUser = (state, { highlightsByUser }) => {
  return state.merge({ highlightsByUser });
};

const setLoader = (state, { showLoader }) => {
  return state.merge({ showLoader });
};

export const callbacks = [
  {
    actionType: ActionTypes.SET_HIGHLIGHTS_BY_USER,
    actionFunction: setHighlightsByUser,
  },
  {
    actionType: ActionTypes.SET_LOADER_STATUS,
    actionFunction: setLoader,
  },
];
